export const en = {
  ErGingIetsMis: 'Something went wrong. Please try again later or contact customer support.',
};
